import { Analytics } from '../../../modules/analytics/analytics';
import { autoInjectable } from 'tsyringe';
import { PlacementContentDef } from '@ads-ep/fetch-api-client';
import { PlacementConfig } from '../../../models/placement-config.model';
import { PlacementMetadata } from '../../../models/placement-meta-data.model';
import { TemplateFunction } from '../../../models/template-function.model';
import headerTemplate from './base-overlay-header.component.html';
import footerTemplate from './base-overlay-footer.component.html';
import { CommonPlacement } from '../../common-placement/common-placement.component';
import { EpStore } from '../../../services/store/ep-store';

/*
 * This is basically an abstract class and not meant to be
 * instantiated directly. Each placement extends this base
 * component.
 * */
@autoInjectable()
export class BaseOverlayComponent extends CommonPlacement{
  overlayClass = 'base-overlay';
  headerTemplateFn: TemplateFunction = headerTemplate;
  footerTemplateFn: TemplateFunction = footerTemplate;
  templateFn: TemplateFunction;
  templateData: any = {};
  /*
  * Dom element for instance of this component.
  * The template will render into the innerHTML
  * of this dom element.
  * */
  containerEl: HTMLElement;

  /*
  * Component specific view object to be used in the
  * component template's render function. Use cases include
  * calculating the monthly price and using it to replace
  * a mustache variable set in a content string from the
  * server.
  * */
  componentTemplateData: any = {};

  /*
  * Most things could be done in the constructor,
  * but keeping the constructor small to make it easier
  * to test functions independently and handle dependency
  * injection. Also, empty so any classes that extend this
  * one can override the init function instead of the constructor.
  * */
  constructor(
    public placementContent: PlacementContentDef,
    public originPlacementConfig?: PlacementConfig,
    public originMetaData?: PlacementMetadata,
    private analytics?: Analytics,
    protected store?: EpStore,
  ) {
    super();
    /*
    * TODO Decide how to handle missing required placementContent
    * */
    if(!placementContent){
      return;
    }
    /*
    * Merge template data from component with
    * template data from service
    * */
    this.templateData = {
      ...placementContent.contentData || {},
      ...this.componentTemplateData
    };
  }

  /*
  * Maybe change to getOrCreate?
  * */
  getDomElement(): HTMLElement{
    return this.containerEl;
  }

  /*
  * Take array of template functions and
  * */
  render(templateFunctions: TemplateFunction[] = [], templateData: any = {}): string{
    return templateFunctions
      .filter(fn=>!!fn)
      .map(fn=>fn(templateData))
      .join('');
  }

  /*
  * Override to specify code split template to use
  * */
  async getAsyncTemplate(){
    /*
    * Example Code:
    * */
    // const templateFn: (...args: any[]) => string =
    //   await import('./generic-overlay.template.html') as any;
    // this.templateFn = (templateFn as any).default;
    /*
    * END Example code
    * */
  }
  /*
  * Make any analyticsClient calls and clean up dom
  * */
  dispose(): void{

  }

  /*
  * Override this function to change the order or
  * include / exclude specific template functions
  * */
  getTemplateFunctions(): TemplateFunction[]{
    return [
      this.headerTemplateFn,
      this.templateFn,
      this.footerTemplateFn,
    ];
  }

  /*
   * Run after component is created. Code to bind
   * the component to the DOM and add event handlers
   * should go here.
   * */
  async init() {
    /*
    * Create a container element to store the
    * rendered template
    * */
    await this.getAsyncTemplate();

    this.containerEl = document.createElement('div');
    this.containerEl.className = `epjs-css-overlay ${this.overlayClass}`;
    this.containerEl.innerHTML = this.render(this.getTemplateFunctions(), this.templateData);

    this.addEventListeners();
  }

  /*
  * Add any new event listeners here
  * for the overriding component
  * */
  addEventListeners(){

  }

  bindActions(domTarget: HTMLElement): void {
  }
}
